import React, { useEffect, useState } from "react";
import { object } from "prop-types";

import FocusedCard from "../../atoms/FocusedCard";
import ComponentContainer from "../../layouts/component-container";
import CustomSlider from "../../atoms/CustomSlider";

import { componentProps } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./sliderFocusedCard.m.css";

const SliderFocusedCard = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  let {
    items = [],
    autoPlay = false,
    showDots = true,
    numberOfStoriesShow = 4,
    showSectionTag = true,
    theme = "amber",
    numberOfCollectionsToShow = 0,
  } = componentProps(collection);

  if (!items.length) {
    return null;
  }

  const [showCarousel, setShowCarousel] = useState(false);
  const { mobile, tab, desktop } = useDevice();
  const collectionOfCollection = numberOfCollectionsToShow > 0;

  items = items.filter((item) => {
    return collectionOfCollection ? item.type === "collection" : item.type === "story";
  });

  let stories = [];

  if (collectionOfCollection) {
    items.slice(0, numberOfCollectionsToShow).forEach((item) => {
      if (item.type === "collection") {
        const {
          "associated-metadata": { number_of_stories_to_show: numberOfStories = 1 } = {},
          items: childItems = [],
        } = item;
        stories.push(...childItems.filter(({ type }) => type === "story").slice(0, numberOfStories));
      }
    });
  } else {
    stories = items.slice(0, numberOfStoriesShow);
  }

  if (!stories.length) {
    return null;
  }

  const slides = stories.map((story, index) => (
    <FocusedCard
      key={index}
      collectionOfCollection={false}
      story={story.story || story}
      imageType="image3x2"
      aspectRatio={[3, 2]}
      styleName="card"
      showSection={showSectionTag}
      widths={[210, 330, 390]}
    />
  ));

  useEffect(() => {
    if (desktop) {
      setShowCarousel(slides.length > 4);
    } else if (tab) {
      setShowCarousel(slides.length > 3);
    } else if (mobile) {
      setShowCarousel(slides.length > 1);
    }
  }, [mobile, tab, desktop]);

  return (
    <ComponentContainer
      styleName={`base ${theme === "default" ? "default" : "other-theme"}`}
      className={theme}
      collection={collection}
    >
      <div styleName="slider-wrapper">
        {showCarousel ? (
          <CustomSlider
            isNavigation={desktop}
            isAutoplay={autoPlay}
            isPagination={showDots}
            slidesPerView={{ mobileSlides: 1.2, tabSlides: 3.4, desktopSlides: 4.4 }}
            isNoPaddingMobile={true}
            hideDisableIcon={true}
          >
            {slides}
          </CustomSlider>
        ) : (
          <div styleName="story-cards">{slides}</div>
        )}
      </div>
    </ComponentContainer>
  );
};

SliderFocusedCard.propTypes = {
  collection: object,
};

SliderFocusedCard.storyLimit = 12;
SliderFocusedCard.nestedCollectionLimit = [1, 1, 1, 1, 1, 1, 1, 1];

export default SliderFocusedCard;
